import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingWorkflow } from '../editor-booking-item-setting/editor-booking-item-setting-workflow.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-workflow',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryWorkflowComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingWorkflow;
  @Input() first: boolean;
  @Input() last: boolean;

  private destroyed$ = new Subject<void>();

  workflowNames: { id: string, name: string }[];

  summary: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.workflowNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(workflowNames => {
        this.workflowNames = workflowNames;
        this.summary = this.getSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      if (this.workflowNames !== undefined) {
        this.summary = this.getSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getSummary(): string {
    let summary = this.itemSetting.getIdAsString(this.workflowNames);

    if (summary === '') {
      return summary;
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
